// test23
(23 && 0);
